/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step5_Sync_Not_AvailableInputs */



/**
* | output |
* | --- |
* | "(Not available for local storage)" |
*
* @param {Spaces_Wizard_Step5_Sync_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step5_sync_not_available = /** @type {((inputs?: Spaces_Wizard_Step5_Sync_Not_AvailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step5_Sync_Not_AvailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("(Nicht verfügbar für lokalen Speicher)")
	return /** @type {LocalizedString} */ ("(Not available for local storage)")
});